import React, { Component } from 'react';
import PasswordResetRequest from "../components/PasswordResetRequest";
import styled from 'styled-components';
import NavLink from 'react-router-dom/NavLink';
import Icon from "@material-ui/core/Icon";
import {withTranslation} from "react-i18next";

const StyledContainer = styled.div`
  position: relative;
  top: 40vh;
  transform: translateY(-50%);
  display: inline-block;
  max-width: 475px;
  
  .go-back {
    padding: 10px;
    text-align: left;
    
    * {
      vertical-align: middle;
    }
  }
`;

class RequestResetPasswordPage extends Component {
    render() {
        return (
            <StyledContainer>
                <div className={'go-back'}>
                    <NavLink to={'/'}>
                        <Icon>keyboard_arrow_left</Icon>
                        {this.props.t('common.goBack')}
                    </NavLink>
                </div>
                <PasswordResetRequest></PasswordResetRequest>
            </StyledContainer>
        )
    }
}

export default withTranslation()(RequestResetPasswordPage);
